export const descriptions = {
  average_learner_rating: 'Star Ratings',
  average_learner_effort: 'Effort Ratings',
  percent_quests_recommended: 'Recommendations',
  quests_in_progress_by_learners_count: 'Active Quests',
  quests_completed_by_learners_count: 'Completed Quests'
}

export const tooltipText = {
  average_learner_rating: 'Average student rating of your quests (1-5)',
  average_learner_effort: 'Average student effort rating of your quests (1-3)',
  percent_quests_recommended: '% of students that recommend your quests',
  quests_in_progress_by_learners_count:
    'Students working on your quests right now',
  quests_completed_by_learners_count: 'Your quests completed by students'
}

export const hasCompletedQuests = stats => {
  // handles userstats for MyQuests and learnerstats for Quest Detail
  return (
    Boolean(stats.quests_completed_by_learners_count) ||
    Boolean(stats.quests_completed_count)
  )
}

export const formatQuestCountDisplay = value => {
  let retVal = value.toString()

  if (retVal > 9999 && retVal < 1000000) {
    retVal =
      Math.floor(retVal / 1000)
        .toFixed(0)
        .toString() + 'k'
  } else if (retVal >= 1000000 && retVal < 99999999) {
    retVal = parseFloat((retVal / 1000000).toFixed(1)).toString() + 'm'
  } else if (retVal >= 99999999) {
    retVal = '99.9m'
  }

  return retVal
}



// WEBPACK FOOTER //
// ./src/utils/userstats.js